import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';
import Badge from '@mui/material/Badge';
import IconButton from '@mui/material/IconButton';
import type { ReactElement } from 'react';

export type NotificationBellProps = {
    hasNotifications?: boolean;
    onClick?: () => void;
};

export function NotificationBell({ hasNotifications = false, onClick }: NotificationBellProps): ReactElement {
    return (
        <Badge
            variant="dot"
            color="error"
            invisible={!hasNotifications}
            overlap="circular"
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            sx={{ '& .MuiBadge-badge': { transform: 'none', bottom: 8, right: 8 } }}>
            <IconButton onClick={onClick}>
                <NotificationsOutlinedIcon />
            </IconButton>
        </Badge>
    );
}
